const common = {
  activeFilters_one: '{{count}} active filter',
  activeFilters_other: '{{count}} active filters',
  add: 'Add',
  addComment: 'Add a comment',
  admin: 'Admin',
  after: 'After',
  and: 'and',
  anyDueDate: 'Any',
  anyImportance: 'Any',
  applyFilters: 'Apply',
  archive: 'Archive',
  assignee: 'Assignee',
  assignees: 'Assignees',
  backToHome: 'Back to home',
  blocked: 'Blocked',
  boolean: 'Boolean',
  cancel: 'Cancel',
  cancelled: 'Cancelled',
  cancelReason: 'Cancellation reason',
  cancelReasonPlaceholder: 'Why is this being cancelled?',
  cancelReasonPrompt: 'Why is this being cancelled?',
  cardsView: 'Cards view',
  clearFilters: 'Clear',
  collapse: 'Collapse',
  color: 'Color',
  comment: 'Comment',
  comments: 'Comments',
  commentTooLong: 'A comment can be at most {{max}} characters.',
  completed: 'Completed',
  completion: 'Completion',
  confirmCancellation: 'Mark as cancelled',
  couldNotSaveComment: 'Could not save the comment.',
  couldNotSaveTask: 'Could not save the task.',
  create: 'Create',
  created: 'Created',
  custom: 'Custom',
  daily: 'Daily',
  date: 'Date',
  day: 'Day',
  dayOfMonth: 'Day of the month',
  daysOfWeek: 'Days of the week',
  deadline: 'Deadline',
  delete: 'Delete',
  deleted: 'Deleted',
  description: 'Description',
  details: 'Details',
  discussion: 'Discussion',
  documentation: 'Documentation',
  doing: 'Doing',
  dueDate: 'Due Date',
  dueThisWeek: 'This week',
  dueToday: 'Today',
  duplicate: 'Duplicate',
  duration: 'Duration',
  edit: 'Edit',
  edited: 'edited',
  end: 'End',
  ends: 'Ends',
  expand: 'Expand',
  exportToCsv: 'Export to CSV',
  failed: 'Failed',
  feedback: 'Feedback',
  fields: 'Fields',
  filters: 'Filters',
  friday: 'Friday',
  history: 'History',
  home: 'Home',
  hour: 'Hour',
  hours: 'Hours',
  icon: 'Icon',
  importance: 'Importance',
  importanceHigh: 'High',
  importanceLow: 'Low',
  importanceMedium: 'Medium',
  informations: 'Informations',
  invalidSubmission: 'Invalid submission',
  last: 'Last',
  lastUpdate: 'Last update',
  listView: 'List view',
  loading: 'Loading',
  markAsCancelled: 'Mark as cancelled',
  markAsCompleted: 'Mark as completed',
  monday: 'Monday',
  month: 'Month',
  monthly: 'Monthly',
  name: 'Name',
  never: 'Never',
  no: 'No',
  noCommentsToDisplay: 'No comments to display',
  noDueDate: 'No due date',
  noImportance: 'No importance',
  noFieldsToDisplay: 'No fields to display',
  noHistoryToDisplay: 'No history to display',
  noSearchResults: 'No results match your search',
  note: 'Note',
  notDone: 'Not done',
  notifications: 'Notifications',
  nthWeekday: 'Weekday',
  number: 'Number',
  occurrences: 'occurrences',
  onDate: 'On a date',
  onThe: 'On the',
  openInFullPage: 'Open in full page',
  or: 'or',
  ordinalFifth: 'Fifth',
  ordinalFirst: 'First',
  ordinalFourth: 'Fourth',
  ordinalSecond: 'Second',
  ordinalThird: 'Third',
  overdue: 'Overdue',
  pageNotFound: 'Page not found',
  pageNotFoundDescription: 'This page does not exist, or you do not have access to it.',
  privacy: 'Privacy',
  progress: 'Progress',
  recurrence: 'Recurrence',
  reopen: 'Reopen',
  repeatEvery: 'Repeat every',
  required: 'Required',
  saturday: 'Saturday',
  save: 'Save',
  search: 'Search',
  searchResults: 'Search results',
  selectAtMostXItems: 'Please select at most {{count}} items.',
  showingXToYOfZ: 'Showing {{from}}–{{to}} of {{total}}',
  start: 'Start',
  startDate: 'Start Date',
  stats: 'Stats',
  status: 'Status',
  sunday: 'Sunday',
  termsOfService: 'Terms of Service',
  text: 'Text',
  thursday: 'Thursday',
  time: 'Time',
  timeLeft: 'Time Left',
  timesheet: 'Timesheet',
  todo: 'To do',
  tuesday: 'Tuesday',
  type: 'Type',
  unassigned: 'Unassigned',
  unknownUser: 'Unknown user',
  version: 'v{{version}}',
  wednesday: 'Wednesday',
  week: 'Week',
  weekly: 'Weekly',
  writeAComment: 'Write a comment',
  year: 'Year',
  yearly: 'Yearly',
  yes: 'Yes',
};

export default common;
